import SgpTitle from './title.vue'

SgpTitle.install = function (Vue) {
  Vue.component(SgpTitle.name, SgpTitle)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(SgpTitle)
}

export default SgpTitle

